webpackJsonp([71],{

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1288);


/***/ }),

/***/ 1288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(177);

var _datetime2 = _interopRequireDefault(_datetime);

var _pt = __webpack_require__(795);

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('pt', _pt2.default);

/***/ })

},[1287]);


// WEBPACK FOOTER //
// app/datetime.pt-55a06bfbb66a4925dc8b.js